<!--
// app/components/Shared/ButtonEcalSync.vue
-->
<script setup lang="ts">
import { useCompetitionStore } from "~/stores/competitionStore";
import { useWebContext } from "~/composables/webContext";

type Props = {
  inTitle?: boolean;
  asButton?: boolean;
  widgetId?: string;
};

const props = defineProps<Props>();

const { region } = useCompetitionStore();
const { isKings } = useWebContext();

const ecalWidgetId =
  region && region.ecalWidgetId
    ? region.ecalWidgetId
    : props.widgetId
      ? props.widgetId
      : "67d21c1cc190f40008290c47";

const apiKey = "uJkAgacB3SwoqvaJbQrrzOxQ4NcZVLAXeDTcHj1ErW467cf8fa";

function initializeEcal() {
  if (window.EcalWidget && typeof window.EcalWidget.init === "function") {
    window.ECAL_SYNC_WIDGET = window.EcalWidget.init({ apiKey });
  }
}

function injectEcalScriptAndInit() {
  if (window.EcalWidget) {
    initializeEcal();
    return;
  }

  const script = document.createElement("script");
  script.src = "//sync.ecal.com/button/v1/main.js?t=" + Date.now();
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    initializeEcal();
  };
}

onMounted(() => {
  injectEcalScriptAndInit();
});
</script>

<template>
  <div v-if="ecalWidgetId && isKings" :class="[inTitle || asButton ? 'max-w-max' : 'text-center my-2 mx-2']">
    <button
      class="ecal-sync-widget-button"
      :class="[
        'btn btn-emphasis flex items-center justify-start gap-1',
        { 'text-xs !py-1 !px-2': !asButton },
        { 'text-xs lg:text-sm !py-1.5': asButton },
      ]"
      :data-ecal-widget-id="ecalWidgetId"
      data-ecal-no-styling
    >
      <span>
        <svg
          class="w-5 h-5 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 9.05H3v2h1v-2Zm16 2h1v-2h-1v2ZM10 14a1 1 0 1 0 0 2v-2Zm4 2a1 1 0 1 0 0-2v2Zm-3 1a1 1 0 1 0 2 0h-2Zm2-4a1 1 0 1 0-2 0h2Zm-2-5.95a1 1 0 1 0 2 0h-2Zm2-3a1 1 0 1 0-2 0h2Zm-7 3a1 1 0 0 0 2 0H6Zm2-3a1 1 0 1 0-2 0h2Zm8 3a1 1 0 1 0 2 0h-2Zm2-3a1 1 0 1 0-2 0h2Zm-13 3h14v-2H5v2Zm14 0v12h2v-12h-2Zm0 12H5v2h14v-2Zm-14 0v-12H3v12h2Zm0 0H3a2 2 0 0 0 2 2v-2Zm14 0v2a2 2 0 0 0 2-2h-2Zm0-12h2a2 2 0 0 0-2-2v2Zm-14-2a2 2 0 0 0-2 2h2v-2Zm-1 6h16v-2H4v2ZM10 16h4v-2h-4v2Zm3 1v-4h-2v4h2Zm0-9.95v-3h-2v3h2Zm-5 0v-3H6v3h2Zm10 0v-3h-2v3h2Z"
          />
        </svg>
      </span>
      <span class="hidden bigsm:inline-flex">{{ $t("button.addCalendar") }}</span>
    </button>
  </div>
</template>

<style scoped></style>
